import { FC, ReactElement, useRef, useState, useEffect } from 'react';
import styled from '@emotion/styled';
import TopBar from '../connected/TopBar';
import SideBar from '../connected/SideBar';
import Footer from '../connected/Footer';

type Props = {
  children: ReactElement<any>;
  className?: string;
};

const LiftReportLayout: FC<Props> = ({ children, className }) => {
  const [height, setHeight] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight);
    }
  });

  const mainStyle = {
    paddingTop: height,
  };

  return (
    <Root className={className}>
      <TopBar />
      <SideBar />
      <Content style={mainStyle}>
        {children}
        <Footer />
      </Content>
    </Root>
  );
};

const Root = styled('div')({
  height: '100%',
  paddingLeft: 302,
});

const Content = styled.main((props) => ({
  height: '100%',
  paddingTop: props.style ? props.style.paddingTop : undefined,
}));

export default LiftReportLayout;
